"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ceppaloni": {
    "414aa413": [{
      "hkey": "d7ba1ffa",
      "slug": "beltiglio-san-giovanni",
      "name": "Beltiglio-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "beltiglio": [{
      "hkey": "d7ba1ffa",
      "slug": "beltiglio-san-giovanni",
      "name": "Beltiglio-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6cdcb755": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "skipSearch": false
    }],
    "brecciale": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e654730": [{
      "hkey": "d7ba1ffa",
      "slug": "beltiglio-san-giovanni",
      "name": "Beltiglio-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "confini": [{
      "hkey": "d7ba1ffa",
      "slug": "beltiglio-san-giovanni",
      "name": "Beltiglio-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ceppaloni"
    }],
    "24be35fe": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "skipSearch": false
    }],
    "martini": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bed0b9e3": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "skipSearch": false
    }],
    "masseria-rotola": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9eb4e07a": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "skipSearch": false
    }],
    "petrara": [{
      "hkey": "19bc6b5a",
      "slug": "ceppaloni",
      "name": "Ceppaloni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e216431a": [{
      "hkey": "d7ba1ffa",
      "slug": "beltiglio-san-giovanni",
      "name": "Beltiglio-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "d7ba1ffa",
      "slug": "beltiglio-san-giovanni",
      "name": "Beltiglio-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ceppaloni"
    }],
    "37dfbb72": [{
      "hkey": "d02497b1",
      "slug": "tressanti-tufara-valle",
      "name": "Tressanti-Tufara Valle",
      "primary": true,
      "skipSearch": false
    }],
    "tressanti": [{
      "hkey": "d02497b1",
      "slug": "tressanti-tufara-valle",
      "name": "Tressanti-Tufara Valle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;